import React from "react";
// ANT DESIGN COMPONENTS
import { Select } from "antd";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// INTERFACES
import { ResponseKind } from "../../../interfaces/AdapterCdoModbus.interface";

export default function FormSelectResponseMessageResponse({
	inputValue,
	inputOnChange,
	disabledInput,
}: {
	inputValue: ResponseKind;
	inputOnChange: (newValue: ResponseKind) => void;
	disabledInput: boolean;
}) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const { Option } = Select;
	const [t] = useTranslation("global");
	const OPTIONS: ResponseKind[] = [
		"ReadCoilsResponse",
		"ReadDiscreteInputsResponse",
		"ReadHoldingRegistersResponse",
		"ReadInputRegistersResponse",
		"ReadWriteMultipleRegistersResponse",
		"WriteSingleCoilResponse",
		"WriteMultipleCoilsResponse",
		"WriteSingleRegisterResponse",
		"WriteMultipleRegistersResponse",
		"ReportServerIdResponse",
		"MaskWriteRegisterResponse",
		"CustomResponse",
	];

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */

	// ************************************************ */
	// USE EFFECT ************************************* */

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div className='col-md-12 mt-3'>
			<div className='generalStyles__flex'>
				<div className='generalStyles__inputFlexNameLarge'>
					<span className='generalStyles__inputFlexRequired'>*</span>
					<span>{t("general.contentType")}</span>
				</div>
				<div className='generalStyles__width100'>
					<Select
						className='generalStyles__width100'
						size='small'
						onChange={(e: any) => {
							inputOnChange(e);
						}}
						value={inputValue}
						disabled={disabledInput}
					>
						{OPTIONS.map((item: string) => (
							<Option key={item} value={item}>
								{item.replace(/_/g, " ")}
							</Option>
						))}
					</Select>
				</div>
				<div className='generalStyles__infoTooltipIconBlank' />
			</div>
		</div>
	);
}
